import {
  TransactionActionTypes,
  ADD_TRANSACTION,
  FINISH_TRANSACTION,
  SYNC_TRANSACTIONS_STATE,
} from '../../types/actions/Transaction.actions';

export interface TransactionState {
  data: {
    [hash: string]: {
      hash: string;
      summary: string;
      from: string;
      addedTime: number;
      status?: 0 | 1;
      confirmedTime?: number;
      completeMessage?: string;
      errorMessage?: string;
    };
  };
  transactions: string[];
  pending: string[];
}

const initialState: TransactionState = {
  data: {},
  transactions: [],
  pending: [],
};

export default (
  state = initialState,
  action: TransactionActionTypes,
): TransactionState => {
  switch (action.type) {
    case ADD_TRANSACTION: {
      const newState = {...state};
      newState.data[action.hash] = action.payload;
      newState.transactions = [
        ...new Set([...state.transactions, action.hash]),
      ];
      newState.pending = [...new Set([...state.pending, action.hash])];
      return newState;
    }

    case FINISH_TRANSACTION: {
      const newState = {...state};
      newState.data[action.hash].confirmedTime = action.payload.confirmedTime;
      newState.data[action.hash].status = action.payload.status;
      const pending = [...state.pending];
      pending.splice(
        pending.findIndex((hash) => hash === action.hash),
        1,
      );
      newState.pending = pending;
      return newState;
    }

    case SYNC_TRANSACTIONS_STATE: {
      if (action.payload && typeof action.payload === 'object') {
        return {
          ...state,
          ...action.payload,
        };
      }
      return state;
    }

    default:
      return state;
  }
};
